import { Component, OnInit } from '@angular/core';
import { DISPLAY_DATE_FORM } from '@core/constants/time.defaults';
import { GlobalDataService } from '../../../services/global-data.service';
import moment from 'moment';
interface IVersion {
  title: string;
  date: string;
  sections: IversionSection[];
}
interface IversionSection {
  title: string;
  children: string[];
}
@Component({
  selector: 'app-app-version',
  standalone: false,
  templateUrl: './app-version.component.html',
})
export class AppVersionComponent implements OnInit {
  versions: IVersion[] = [];
  constructor(private globalHelper: GlobalDataService) {}
  get maxAgents() {
    return this.globalHelper.$applicationStatus.getValue().maxAgents;
  }
  get agentsExpiration() {
    return this.globalHelper.$applicationStatus.getValue().agentsExpiration;
  }
  get expirationDate() {
    const date = this.globalHelper.$applicationStatus.getValue().expirationDate;
    return moment(date).format(DISPLAY_DATE_FORM).toString();
  }
  get timeUntilAgentExpiration() {
    return this.globalHelper.$applicationStatus.getValue()
      .timeUntilAgentExpiration;
  }
  ngOnInit(): void {
    this.versions = this.globalHelper.$settings.getValue().versions;
  }
}
